export class AgencyInfo {
	public extensionData : String;
	public iatacode : string;
	public personOrgId : Number;
	public contact : String;
	public firstname : String;
	public lastname : String;
	public currencyCode : String;
	public parentIataCode : String;
	public accountNumber : String;
	public agencyName : String;
	public userName : String;
	public accountExpiration : String;
	public commission : Number;
	public creditLimit : Number;
	public actualCreditLimit : Number;
	public fetExempt : Boolean;
	public bankNumber : String;
	public travelAgentStatus : String;
	public consortTravalAgentId : Number;
	public fareBasisCode : String;
	public accountId : String;
	public federalId : String;
	public emailReceipt : Boolean;
	public faxReceipt : Boolean;
	public mailReceipt : Boolean;
	public comments : String;
	public prepaid : Boolean;
	public travelAgentTypeId : Number;
	public canViewAllPnrs : Number;
	public address1 : String;
	public address2 : String;
	public companyName : String;
	public city : String;
	public state : String;
	public zipCode : String;
	public country : String;
	public phone : String;
	public phoneCode : String;
	public email : String;
	public fax : String;
	public travelAgentUserName : String;
	public modifyFlag : boolean;
	public recieptOption : string;
	constructor(obj ?: Object) {
		if(obj) {
			this.extensionData = obj['extensionData'] || '';
			this.iatacode = obj['iatacode'] || '';
			this.personOrgId = obj['personOrgId'] || '';
			this.contact = obj['contact'] || '';
			this.firstname = obj['firstname'] || '';
			this.lastname = obj['lastname'] || '';
			this.currencyCode = obj['currencyCode'] ||  obj['currency']|| '';
			this.parentIataCode = obj['parentIataCode'] || '';
			this.accountNumber = obj['accountNumber'] || '';
			this.agencyName = obj['agencyName'] || '';
			this.userName = obj['agencyName'] || '';
			this.accountExpiration = obj['accountExpiration'] || '';
			this.commission = obj['commission'] || '';
			this.creditLimit = obj['creditLimit'] || '';
			this.fetExempt = obj['fetExempt'] || '';
			this.bankNumber = obj['bankNumber'] || '';
			this.travelAgentStatus = obj['travelAgentStatus'] || '';
			this.consortTravalAgentId = obj['consortTravalAgentId'] || '';
			this.fareBasisCode = obj['fareBasisCode'] || '';
			this.accountId = obj['accountId'] || '';
			this.federalId = obj['federalId'] || '';
			this.emailReceipt = obj['emailReceipt'] || '';
			this.faxReceipt = obj['faxReceipt'] || '';
			this.mailReceipt = obj['mailReceipt'] || '';
			this.comments = obj['comments'] || '';
			this.prepaid = obj['prepaid'] || '';
			this.travelAgentTypeId = obj['travelAgentTypeId'] || '';
			this.canViewAllPnrs = obj['canViewAllPnrs'] || '';
			this.address1 = obj['address1'] || '';
			this.address2 = obj['address2'] || '';
			this.companyName = obj['companyName'] || '';
			this.city = obj['city'] || '';
			this.state = obj['state'] || '';
			this.zipCode = obj['zipCode'] || '';
			this.country = obj['country'] || '';
			this.phone = obj['phone'] || '';
			this.phoneCode = obj['phoneCode'] || '';
			this.email = obj['email'] || '';
			this.fax = obj['fax'] || '';
			this.travelAgentUserName = obj['travelAgentUserName'] || '';
			this.modifyFlag = false;
			this.recieptOption =obj['recieptOption'] || '';
			this.actualCreditLimit =obj['actualCreditLimit'] || ''; 
		}
	}
};

export class AgencyList {
	public iatacode : string;	
	public numberOfBookings : String;
	public travelAgentStatus : String;
	public agencyName : String;
	public creditLimit : Number;
	public currencyCode: String;

	constructor(obj?: Object){
		this.iatacode = obj['iatacode'];
		this.numberOfBookings = obj['numberOfBookings'];
		this.travelAgentStatus = obj['travelAgentStatus'];
		this.agencyName = obj['agencyName'];
		this.creditLimit = obj['availableBalance'];
		this.currencyCode = obj['currencyCode'];
	}
};


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/agency.model.ts